import { database } from '../firebase';
export const LAST_UPDATED = 'LAST_UPDATED';

export const fetchUpdate = () => async dispatch => {

    database.ref("/updates").once("value", snapshot => {
        dispatch({
            type: LAST_UPDATED,
            payload: snapshot.val()
        });
    });
};

export const updateTime = () => async dispatch => {
    let updates = {};

    updates['/updates/last_updated'] = new Date();


    database.ref().update(updates).then(function (value) {
        console.log(value);
    });
};